import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazySelectCarrierRoute = lazy(() => retry(() => import('app/pages/admin/SelectCarrier')));
const LazySelectCarriersRoute = lazy(() => retry(() => import('app/pages/admin/SelectCarriers')));

export const SelectCarrier = (props: ComponentProps) => <LazySelectCarrierRoute {...props} />;
export const SelectCarriers = (props: ComponentProps) => <LazySelectCarriersRoute {...props} />;
